import React, { useMemo } from 'react';

import { ClaimMatchingType } from '@/modules/employer/components/Lockbox/lockbox.types';
import { SuccessMessage, WarningMessage } from '@/modules/employer/components/Lockbox/LockboxDetails/components/LockboxInfo/LockboxMatchingList';

interface Props {
  matchingType?: ClaimMatchingType;
}

const ClaimMatchingMessage: React.FC<Props> = ({ matchingType }) => {
  const message = useMemo(() => {
    switch (matchingType) {
    case ClaimMatchingType.FULL_MATCH: {
      return <SuccessMessage title="Claim Number and Employee Name Matched" />;
    }
    case ClaimMatchingType.EMPLOYEE_NAME_NOT_MATCHED: {
      return <WarningMessage title="Employee Name Doesn't Match" />;
    }
    default: {
      return null;
    }
    }
  }, [matchingType]);

  return message;
};

export default ClaimMatchingMessage;
